<template>
	<div :class="['nk-badges', systemBorder]">
		<div v-if="showHome" :class="['nk-badge', this.systemBorder]" @click="navigateToHome" style="cursor: pointer">
			<icon name="home-lg-alt" />
		</div>
		<slot></slot>
	</div>
</template>
<script>
	export default {
		props: {
			system: { type: String, required: false },
			showHome: { type: Boolean, default: true }
		},
		data() {
			return {

			}
		},
		computed: {
			systemBorder() {
				if (this.system && this.system !== '') {
					return 'system ' + this.system
				}

				return undefined
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			navigateToHome() {
				this.$openTab('home')
			},
		},
	}
</script>
<style></style>
